import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL, USER_URL } from "../../constant/api";
import NotificationCard from "../../components/NotificationCard/NotificationCard";

function ProfileNotification() {
  const [notifications, setNotifications] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await USER_URL.get(`/orders/notifications/`);
        console.log(response);
        setNotifications(response.data.Data.reverse()); // Adjust based on your API response structure
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    };

    fetchNotifications();
  }, [token]);

  return (
    <div className="relative z-20 bg-white rounded-2xl p-4 h-auto">
      <div className="flex flex-col text-brand-primary">
        <h1 className="font-semibold text-[20px] pt-4">Notifications</h1>
      </div>

      <div className="grid gap-2 bg-white rounded-md shadow p-4 my-3 lg:me-7 mb-2">
        {notifications.length > 0 ? (
          <NotificationCard notifications={notifications} />
        ) : (
          <p className="text-gray-500 text-center mt-4">
            No notifications available.
          </p>
        )}
      </div>
    </div>
  );
}

export default ProfileNotification;
